import { zip as zip_lodash } from 'lodash';

// Overload signatures
export function zip<T, U>(listA: T[], listB: U[]): [T, U][];
export function zip<T, U, K>(listA: T[], listB: U[], listC: K[]): [T, U, K][];
export function zip<T, U, K, L>(
  listA: T[],
  listB: U[],
  listC: K[],
  listD: L[]
): [T, U, K, L][];

// Implementation signature (not visible to callers)
export function zip<T, U, K, L>(
  listA: T[],
  listB: U[],
  listC?: K[],
  listD?: L[]
): [T, U][] | [T, U, K][] | [T, U, K, L][] {
  if (listC === undefined) {
    if (listA.length !== listB.length) {
      throw Error('Both lists must have the same length');
    }
    return zip_lodash(listA, listB) as [T, U][];
  }
  if (listD === undefined) {
    if (listA.length !== listB.length || listA.length !== listC.length) {
      throw Error('All lists must have the same length');
    }
    return zip_lodash(listA, listB, listC) as [T, U, K][];
  }
  if (
    listA.length !== listB.length ||
    listA.length !== listC.length ||
    listA.length !== listD.length
  ) {
    throw Error('All lists must have the same length');
  }
  return zip_lodash(listA, listB, listC, listD) as [T, U, K, L][];
}
